export default {
    data() {
        return {
            error: null,
        };
    },

    created() {
        if (this.name && window.App && window.App.errors && {}.hasOwnProperty.call(window.App.errors, this.name)) {
            this.error = window.App.errors[this.name][0];
        }
    },
};
